import {SearchResultsLi} from "./search-results-li";
import {OptionItem} from "./option-item";

export function SearchResults(resultsContainerEl, onItemClick) {
    this.containerElement = resultsContainerEl;
    this.recordCountElements = resultsContainerEl.getElementsByClassName('total-record-count-value');
    this.recordsBeginIndexElement = resultsContainerEl.getElementsByClassName('records-begin-index')[0];
    this.recordsEndIndexElement = resultsContainerEl.getElementsByClassName('records-end-index')[0];
    this.listElement = resultsContainerEl.getElementsByTagName('ul')[0];
    this.liList = [];
    this.noMatchesElement = resultsContainerEl.getElementsByClassName('no-matches')[0];
    this.searchingElement = resultsContainerEl.getElementsByClassName('searching')[0];

    this.attachClickCancelListener = function (cancelFn) {
        this.containerElement.addEventListener('click', cancelFn);
    };

    this.setSearching = function (show) {
        this.listElement.innerText = '';
        if (show) {
            this.noMatchesElement.className = 'no-matches';
            this.searchingElement.className = 'searching showing';
        } else {
            this.searchingElement.className = 'searching';
        }
    };

    this.setNoMatches = function (show) {
        if (show) {
            this.searchingElement.className = 'searching';
            this.noMatchesElement.className = 'no-matches showing';
        } else {
            this.noMatchesElement.className = 'no-matches';
        }
    };

    this.update = function (selection, results) {
        let i;
        const count = results.total;
        const values = results.values;

        this.liList = [];
        this.listElement.innerText = '';
        for (i = 0; i < this.recordCountElements.length; i++) {
            this.recordCountElements[i].innerText = count;
        }
        this.setNoMatches(!values.length);

        for (i = 0; i < values.length; i++) {
            const value = values[i].value;
            const label = values[i].label;
            const selected = isInList(value, selection);
            const li = new SearchResultsLi(value, label, selected, onItemClick);
            this.liList.push(li);
            this.listElement.appendChild(li.elem());
        }

        this.listElement.scrollTop = 0;
    };

    this.updateSelection = function (selection) {
        for (let i = 0; i < this.liList.length; i++) {
            const li = this.liList[i];
            const value = li.item.value;
            li.setSelected(isInList(value, selection))
        }
    };

    function isInList(value, list) {
        for (let i = 0; i < list.length; i++) {
            if (value === list[i])
                return true;
        }

        return false;
    }

    this.length = function () {
        return this.listElement.children.length;
    };

    this.hover = function (idx) {
        for (let i = 0; i < this.length(); i++) {
            const child = this.listElement.children[i];
            if (idx === i) {
                child.className = 'hover';
                if (child.offsetTop >= (this.listElement.offsetHeight + this.listElement.scrollTop)) {
                    this.listElement.scrollTop += child.offsetHeight;
                } else if (child.offsetTop < this.listElement.scrollTop) {
                    this.listElement.scrollTop = (child.offsetTop - child.offsetHeight);
                }
            } else {
                if (child.className.indexOf('selected') > 0) {
                    child.className = 'selected';
                } else {
                    child.className = '';
                }
            }
        }
    };

    this.getHovered = function () {
        const listItem = this.listElement.getElementsByClassName('hover')[0];
        if (listItem) {
            return new OptionItem(listItem.dataset.value, listItem.innerText);
        }

        return null;
    };

    this.getHoveredIndex = function () {
        for (let i = 0; i < this.listElement.children.length; i++) {
            if (this.listElement.children[i].className.indexOf('hover') >= 0) {
                return i;
            }
        }

        return -1;
    }
}